import { render } from "./kios-po-summary.vue?vue&type=template&id=70d46faf&scoped=true"
import script from "./kios-po-summary.vue?vue&type=script&lang=js"
export * from "./kios-po-summary.vue?vue&type=script&lang=js"

import "./kios-po-summary.vue?vue&type=style&index=0&id=70d46faf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d46faf"]])

export default __exports__